import * as React from 'react'
import type { SVGProps, Ref } from 'react'
import { forwardRef } from 'react'
interface SVGRProps {
  title?: string
  titleId?: string
}
const SvgQuestionMarkCircleGhost1 = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='1em'
    height='1em'
    fill='none'
    viewBox='0 0 24 24'
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fill={props.color}
      fillRule='evenodd'
      d='M4.539 4.539C6.285 2.793 8.829 2 12 2c3.17 0 5.715.793 7.461 2.539S22 8.829 22 12c0 3.17-.793 5.715-2.539 7.461S15.171 22 12 22c-3.17 0-5.715-.793-7.461-2.539S2 15.171 2 12c0-3.17.793-5.715 2.539-7.461'
      clipRule='evenodd'
      opacity={0.2}
    />
    <path
      fill={props.color}
      d='M9.283 6.364c.756-.589 1.734-.868 2.717-.864.984-.004 1.961.275 2.717.864A3.27 3.27 0 0 1 16 9c0 .935-.24 1.652-.666 2.225-.37.498-.849.834-1.191 1.074l-.067.047c-.383.27-.616.452-.784.695-.148.214-.292.551-.292 1.192a1 1 0 1 1-2 0c0-.976.23-1.726.646-2.328.392-.568.904-.93 1.27-1.188l.008-.005c.405-.286.636-.453.805-.68C13.865 9.848 14 9.565 14 9c0-.466-.192-.809-.513-1.059-.342-.266-.862-.444-1.481-.441h-.011c-.62-.003-1.14.175-1.482.441C10.192 8.191 10 8.534 10 9c0 .23.047.42.12.577a1 1 0 0 1-1.812.845A3.34 3.34 0 0 1 8 9c0-1.118.505-2.03 1.283-2.636M10.75 17.75a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0'
    />
    <path
      fill={props.color}
      fillRule='evenodd'
      d='M3.793 3.793C5.713 1.873 8.513 1 12 1s6.287.873 8.207 2.793S23 8.513 23 12s-.872 6.287-2.793 8.207C18.287 22.127 15.487 23 12 23s-6.287-.872-8.207-2.793C1.873 18.287 1 15.487 1 12s.873-6.287 2.793-8.207m1.414 1.414C3.794 6.62 3 8.821 3 12s.794 5.38 2.207 6.793S8.821 21 12 21s5.38-.794 6.793-2.207S21 15.179 21 12s-.794-5.38-2.207-6.793S15.179 3 12 3s-5.38.794-6.793 2.207'
      clipRule='evenodd'
    />
  </svg>
)
const ForwardRef = forwardRef(SvgQuestionMarkCircleGhost1)
export default ForwardRef
